import { Formik } from 'formik';
import React, { useEffect } from 'react';
import * as yup from 'yup';
import { Dialog } from 'primereact/dialog';
import SharedDropdown from '../../components/Shared/SharedDropdown';
import SharedButton from '../../components/Shared/SharedButton';
import SharedInputText from '../../components/Shared/SharedInputText';
import { useDispatch, useSelector } from 'react-redux';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import CustomSearchDropdown from '../../components/Shared/CustomSearchDropdown';
import { getCashBankAccounts } from '../../store/slices/AcountsSlice';
import { CreateNewInvoicePayment, filterInvoiceData } from '../../store/slices/InvoicesSlice';

export default function ReceivePaymentInvoice({ selectedEntries, open, setOpen, filtersPayload, setFilteredInvoices }) {
  function convertData(data) {
    return data?.length ? data[0].id : '';
  }
  function convertDataa(data) {
    return data?.length ? data[0].patient_share : '';
  }

  const initialValues = {
    invoice_id: convertData(selectedEntries),
    amount: convertDataa(selectedEntries),
    account_code: '',
    date: '',
    payment_method: ''
  };

  const dispatch = useDispatch();
  const lang = i18next.language;
  const { t } = useTranslation();
  const currentDate = new Date().toISOString().split('T')[0];

  const validationSchema = yup.object().shape({
    date: yup.string().required(t('required')),
    payment_method: yup.string().required(t('required'))
    // account_code: yup.number().required(t("required")),
  });

  const paymentOption = [
    { value: 'cash', label: lang === 'ar' ? 'نقدي' : 'Cash' },
    { value: 'bank', label: lang === 'ar' ? 'بنك' : 'Bank' },
    { value: 'mada', label: lang === 'ar' ? 'مدى' : 'MADA' },
    { value: 'cheque', label: lang === 'ar' ? 'يفحص' : 'Cheque' }
  ];

  function handleSubmit(values, { resetForm }) {
    console.log('Vva: ', values);

    dispatch(CreateNewInvoicePayment({ ...values, type: 'sale' })).then(res => {
      if (res?.meta?.requestStatus === 'fulfilled') {
        setOpen(false);
        resetForm();
        dispatch(filterInvoiceData(filtersPayload));
        setFilteredInvoices(null);
      }
    });
  }

  useEffect(() => {
    if (open) {
      // dispatch(getListAccounts());
      dispatch(getCashBankAccounts());
    }
  }, [open]);

  const { cashBankAccounts } = useSelector(state => state?.acount);
  const { isLoading } = useSelector(state => state.invoice);

  const listAccountsvalues = cashBankAccounts?.data
    ? Object.entries(cashBankAccounts.data).map(([id, account]) => ({
        id: Number(account?.code),
        name: lang === 'ar' ? account.name_ar : account.name_en
      }))
    : [];

  return (
    <>
      <Dialog
        header={t('RecordPayment')}
        visible={open}
        onHide={() => {
          if (!open) return;
          setOpen(false);
        }}
        pt={{
          root: { className: 'w-full lg:w-10/12 mx-4 overflow-auto' },
          header: { className: '!p-2 !bg-darkBg !text-white' },
          content: { className: '!p-3' },
          closeButton: {
            className: 'hover:!bg-black/20 !outline-none !shadow-none'
          },
          closeButtonIcon: { className: '!text-white' }
        }}
      >
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
          {props => (
            <>
              <div className='grid grid-cols-4 gap-4'>
                <SharedInputText
                  label={t('date')}
                  name='date'
                  placeholder={`${t('enter')} ${t('date')}`}
                  className='!p-1.5'
                  type={'date'}
                  max={currentDate}
                />
                <SharedDropdown
                  label={t('paymentMethod')}
                  placeholder={`${t('select')} ${t('paymentMethod')}`}
                  name='payment_method'
                  options={paymentOption}
                />
                {/* <CustomSearchDropdown
                  label={t("account")}
                  className="!w-full"
                  name={"account_code"}
                  options={listAccountsvalues}
                  placeholder={`${t("select")} ${t("account")}`}
                /> */}
                <CustomSearchDropdown
                  label={t('account')}
                  className='!w-full'
                  name={'account_code'}
                  options={listAccountsvalues}
                  placeholder={`${t('select')} ${t('account')}`}
                />

                {/* {console.log(props?.errors)} */}
              </div>
              <div className='flex justify-end gap-6 mt-6'>
                <SharedButton
                  icon='pi pi-times'
                  label={t('Cancel')}
                  className='cancel-btn'
                  onClick={() => {
                    setOpen(false);
                    props.resetForm();
                  }}
                />
                <SharedButton
                  type='submit'
                  icon='pi pi-check'
                  label={t('Submit')}
                  className='submit-btn'
                  disabled={isLoading}
                  onClick={props.handleSubmit}
                />
              </div>
            </>
          )}
        </Formik>
      </Dialog>
    </>
  );
}
